import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Footer.css';
import cs from '../commonStyle.css';

import {
  Row,
  Col,
  Grid
} from 'react-bootstrap';
import cx from 'classnames';

// Component
import Link from '../Link';

import PlayStoreImage from '/public/SiteImages/playStore.png';
import AppStoreImage from '/public/SiteImages/appStore.png';
import facebookIcon from '/public/SiteImages/facebook.svg';
import twitterIcon from '/public/SiteImages/twitter.svg';
import instagramIcon from '/public/SiteImages/instagram.svg'

// Locale
import messages from '../../locale/messages';

import getEnabledBlog from './getEnabledBlog.graphql';

class Footer extends React.Component {

  static propTypes = {
    siteName: PropTypes.string.isRequired,
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    instagram: PropTypes.string,
    appAvailableStatus: PropTypes.string,
    playStoreUrl: PropTypes.string,
    appStoreUrl: PropTypes.string,
    formatMessage: PropTypes.any,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getEnabledBlog: PropTypes.array,
    })
  };

  constructor(props) {
    super(props);

  }

  render() {
    const { siteName, facebook, twitter, instagram, appAvailableStatus, playStoreUrl, appStoreUrl } = this.props;
    const { data: { getEnabledBlog } } = this.props;

    return (
      <footer>
        <div
          className={cx(s.footerBgBanner, 'footerBannerToggle', 'commonWordBreak', s.footerSectionPadding, 'bgBlackTwo')} >
          <Grid fluid className={cx(s.footerSectionContainer, 'hidden-print')}>
            <Row>
              <Col sm={12} md={12} lg={12} xs={12}>
                <div className={s.displayGrid}>
                  <div>
                    <label className={cx(s.landingLabel, cs.space1)}>{siteName}</label>
                    <ul className={s.listContainer}>
                      <li className={cs.spaceTop2}>
                        <Link to={'/about'} className={cx(s.textLink, 'darkModeFooterLink')} >
                          <FormattedMessage {...messages.about} />
                        </Link>
                      </li>
                      <li className={cs.spaceTop2}>
                        <Link to={'/contact'} className={cx(s.textLink, 'darkModeFooterLink')} >
                          <FormattedMessage {...messages.contactForm} />
                        </Link>
                      </li>
                      {
                        getEnabledBlog && getEnabledBlog.length > 0 && getEnabledBlog.filter((item) => item.footerCategory != 'discover' && item.footerCategory != 'hosting')
                          .map((item) => {
                            return (
                              <li className={cs.spaceTop2}>
                                <Link to={'/page/' + item.pageUrl} className={cx(s.textLink, 'darkModeFooterLink')} >
                                  {item.pageTitle}
                                </Link>
                              </li>
                            )
                          })
                      }
                    </ul>
                  </div>
                  <div>
                    <label className={cx(s.landingLabel, cs.space1)}><FormattedMessage {...messages.discover} /></label>
                    <ul className={s.listContainer}>
                      <li className={cs.spaceTop2}>
                        <Link to={'/safety'} className={cx(s.textLink, 'darkModeFooterLink')} >
                          <FormattedMessage {...messages.trustSafety} />
                        </Link>
                      </li>
                      {
                        getEnabledBlog && getEnabledBlog.length > 0 && getEnabledBlog.filter((item) => item.footerCategory == 'discover')
                          .map((item) => {

                            return (
                              <li className={cs.spaceTop2}>
                                <Link to={'/page/' + item.pageUrl} className={cx(s.textLink, 'darkModeFooterLink')} >
                                  {item.pageTitle}
                                </Link>
                              </li>
                            )

                          })
                      }
                    </ul>
                  </div>
                  <div>
                    <label className={cx(s.landingLabel, cs.space1)}><FormattedMessage {...messages.hosting} /></label>
                    <ul className={s.listContainer}>
                      <li className={cs.spaceTop2}>
                        <Link to={'/whyhost'} className={cx(s.textLink, 'darkModeFooterLink')} >
                          <FormattedMessage {...messages.becomeAHost} />
                        </Link>
                      </li>
                      <li className={cs.spaceTop2}>
                        <Link to={'/privacy'} className={cx(s.textLink, 'darkModeFooterLink')} >
                          <FormattedMessage {...messages.termsPrivacy} />
                        </Link>
                      </li>
                      {
                        getEnabledBlog && getEnabledBlog.length > 0 && getEnabledBlog.filter((item) => item.footerCategory == 'hosting')
                          .map((item) => {
                            return (
                              <li className={cs.spaceTop2}>
                                <Link to={'/page/' + item.pageUrl} className={cx(s.textLink, 'darkModeFooterLink')} >
                                  {item.pageTitle}
                                </Link>
                              </li>
                            )
                          })
                      }
                    </ul>
                  </div>
                  <div>
                    {
                      appAvailableStatus == 1 && (playStoreUrl || appStoreUrl) &&
                      <div>
                        <label className={cx(s.landingLabel, cs.space3)}><FormattedMessage {...messages.appsAvailableOn} /></label>
                        <div className={s.appsSectionFlex}>
                          {
                            playStoreUrl && <a href={playStoreUrl} target="_blank" className={s.displayInlineBlock}>
                              <img alt="Image" src={PlayStoreImage} />
                            </a>
                          }
                          {
                            appStoreUrl && <a href={appStoreUrl} target="_blank" className={s.displayInlineBlock}>
                              <img alt="Image" src={AppStoreImage} />
                            </a>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div className={s.copyrightSection}>
                  <div>
                    <span className={cx(s.footerSiteName, 'darkModeFooterLink')}>© {siteName}.</span>
                  </div>
                  <div className={s.socialIcons}>
                    {
                      facebook && <a href={facebook} target="_blank" className={cs.cursorPointer}>
                        <img alt="" src={facebookIcon} />
                      </a>
                    }
                    {
                      twitter && <a href={twitter} target="_blank" className={cs.cursorPointer}>
                        <img alt="" src={twitterIcon} />
                      </a>
                    }
                    {
                      instagram && <a href={instagram} target="_blank" className={cs.cursorPointer}>
                        <img alt="" src={instagramIcon} />
                      </a>
                    }
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>
      </footer>
    );
  }
}


const mapState = state => ({
  siteName: state.siteSettings.data.siteName,
  facebook: state.siteSettings.data.facebookLink,
  twitter: state.siteSettings.data.twitterLink,
  instagram: state.siteSettings.data.instagramLink,
  appAvailableStatus: state.siteSettings.data.appAvailableStatus,
  playStoreUrl: state.siteSettings.data.playStoreUrl,
  appStoreUrl: state.siteSettings.data.appStoreUrl
});

const mapDispatch = {};

export default compose(
  injectIntl,
  withStyles(s, cs),
  connect(mapState, mapDispatch),
  graphql(getEnabledBlog,
    {
      options: {
        fetchPolicy: 'network-only',
        ssr: false
      }
    }),
)(Footer);
